import React, { useState, useEffect } from "react";
import FormikControl from '../../../hoc/formikComponents/FormikControl.js'
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import moment from 'moment'
import Select from 'react-select';
import { APIURL } from "../../../hoc/AxiosSetting/axios.js";
import axios from "axios";
import Rfq from "../RFQ/Rfq.js";

function NewContractReview() {
    const history = useHistory();
    const [leadauditorList, setLeadauditorList] = useState([{
        label: "",
        value: ""
    }])
    const [assitAuditorList, setassitAuditorList] = useState([{
        label: "",
        value: ""
    }])
    const [technicalExpertList, setTechnicalExpertList] = useState([{
        label: "",
        value: ""
    }])
    const [auditorList, setauditorList] = useState([{
        label: "",
        value: ""
    }])
    const [initialValues, setInitialValues] = useState({
        orgCode: 0,
        reqDate: new Date(),
        contractDate: new Date(),
        address: "",
        scope: "",
        riskLevel: "",
        nabcbSicCode: "",
        nabcbSicCodeName: "",
        permanentTotal: "",
        partTimeTotal: "",
        contractualTotal: "",
        total: "",
        effectiveNoEmpToBeAudited: "",
        noOfShifts: 0,
        justificationEffNoEmpConsideration: "",
        sitesTobeCoveredInAudit: "",
        nameOfConsultantOrBussinessAsso: "",
        mandays: 0,
        mandaysPlanned: 0,
        stageOneAudit: 0,
        stageTwoAudit: 0,
        remarkforInsDecMandyas: "",
        resonOfTransfer: "",
        threatOne: "No",
        threatOneremark: "",
        threatTwo: "No",
        threatTworemark: "",
        threatThree: "No",
        threatThreeremark: "",
        threatFour: "No",
        threatFourremark: "",
        threatFive: "No",
        threatFiveremark: "",
        threatSix: "No",
        threatSixremark: "",
        threatSeven: "No",
        threatSevenremark: "",
        threatEight: "No",
        threatEightremark: "",
        threatNine: "No",
        threatNineremark: "",
        threatTen: "No",
        threatTenremark: "",
        auditTrainVerification: "Yes",
        scopeCoveredByaccreditation: "Yes",
        outSourceActivity: "",
        notApplicableRequirement: "",
        teamleader: "",
        teamleaderName: "",
        auditorOne: "",
        auditorOneName: "",
        auditorTwo: "",
        auditorTwoName: "",
        applicationAcceptedRejected: "Accepted",
        reviewConductedBy: "",
        externalReviewConductedBy: "",
        approvedBy: "Vijay D",
        appvDate: new Date(),
        reasonForDecline: "",
        increase: "",
        decrease: "",
        increase1: "",
        decrease1: "",
        fruquencyoftask: "Annual",
        surveillancemandays: "",
        reviewerCode: "",
        reviewerName: "",
        certificateactivitytype: "Initial certification",
        certificatestandardtype: ""
    });
  
    const [showData, setShowData] = useState("Iso9001")
    const fruquencyoftask = [
        { key: 'Select', value: '-' },
        { key: '6 Month', value: '6 Month' },
        { key: '9 Month', value: '9 Month' },
        { key: 'Annual', value: 'Annual' }
    ]
    const rsklevel = [
        { key: 'Select', value: '-' },
        { key: 'High', value: 'High' },
        { key: 'Medium', value: 'Medium' },
        { key: 'Low', value: 'Low' }
    ]
    const impartialityoptions = [
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' },
    ]
    const Status = [
        { key: 'Select', value: '-' },
        { key: 'Accepted', value: 'Accepted' },
        { key: 'Rejected', value: 'Rejected' },
    ]
    const Reviews = [
        { key: 'Select', value: '-' },
        { key: 'Secretariat', value: 'Secretariat' },
        { key: 'MT', value: 'MT' },
        { key: 'Executive Support', value: 'Executive Support' }
    ]
    const [reviewerNameList, setReviewerNameList] = useState([
        { key: 'Select', value: 'Select' },
    ])

    const increase = [
        { key: 'Complicated logistics ', value: 'Complicated logistics ' },
        { key: 'Interpreter needed', value: 'Interpreter needed' },
        { key: 'Very large site/number of employees ', value: 'Very large site/number of employees ' },
        { key: 'High degree of regulation', value: 'High degree of regulation ' },
        { key: 'Highly complex processes', value: 'Highly complex processes' },
        { key: 'High number of unique activities', value: 'High number of unique activities' },
        { key: 'Combination of hardware, software, process, and service', value: 'Combination of hardware, software, process, and service ' },
        { key: 'Require visiting temporary sites', value: 'Require visiting temporary sites' },
        { key: 'High Risk Level', value: 'High Risk Level' }
    ]

    const decrease = [
        { key: 'Design and/or other key standard elements absent', value: 'Design and/or other key standard elements absent' },
        { key: 'No/low risk product/processes', value: 'No/low risk product/processes' },
        { key: 'Prior CB knowledge of organization system', value: 'Prior CB knowledge of organization system' },
        { key: 'Very small site for number of employees', value: 'Very small site for number of employees' },
        { key: 'Client preparedness for registration', value: 'Client preparedness for registration' },
        { key: 'Already certified to another system', value: 'Already certified to another system' },
        { key: 'Processes involve a single general activity', value: 'Processes involve a single general activity' },
        { key: 'Maturity of management system', value: 'Maturity of management system' },
        { key: 'High % of employees doing the same, simple tasks', value: 'High % of employees doing the same, simple tasks' },
        { key: 'Identical activities performed on all shifts', value: 'Identical activities performed on all shifts' },
        { key: 'Repetitive Activities', value: 'Repetitive Activities' }

    ]
    const increase1 = [
        { key: 'Complexity of the ISMS (e.g. criticality of information, risk situation if ISMS etc.).', value: 'Complexity of the ISMS (e.g. criticality of information, risk situation if ISMS etc.).' },
        { key: 'Type of Business Performed within scope of ISMS', value: 'Type of Business Performed within scope of ISMS' },
        { key: 'Complicated logistics', value: 'Complicated logistics' },
        { key: 'Interpreter needed', value: 'Interpreter needed' },
        { key: 'Very large site/number of employees ', value: 'Very large site/number of employees ' },
        { key: 'High degree of regulation', value: 'High degree of regulation ' },
        { key: 'Highly complex processes', value: 'Highly complex processes' },
        { key: 'High number of unique activities', value: 'High number of unique activities' },
        { key: 'Combination of hardware, software, process, and service', value: 'Combination of hardware, software, process, and service ' },
        { key: 'Require visiting temporary sites', value: 'Require visiting temporary sites' },
        { key: 'High Risk Level', value: 'High Risk Level' },
        { key: 'extent and diversity of technology utilized in the implementation of the various components of theISMS (e.g. number of different IT platforms, number of segregated networks)', value: 'extent and diversity of technology utilized in the implementation of the various components of theISMS (e.g. number of different IT platforms, number of segregated networks)' },
        { key: 'extent of outsourcing and third party arrangements used within the scope of the ISMS' ,value: 'extent of outsourcing and third party arrangements used within the scope of the ISMS'},
        { key: 'extent of information system development' ,value: 'extent of information system development'},
        { key: 'number of sites and number of Disaster Recovery (DR) sites' ,value: 'number of sites and number of Disaster Recovery (DR) sites'},

    ]

    const decrease1 = [
        { key: 'Design and/or other key standard elements absent', value: 'Design and/or other key standard elements absent' },
        { key: 'No/low risk product/processes', value: 'No/low risk product/processes' },
        { key: 'Prior CB knowledge of organization system', value: 'Prior CB knowledge of organization system' },
        { key: 'Very small site for number of employees', value: 'Very small site for number of employees' },
        { key: 'Client preparedness for registration', value: 'Client preparedness for registration' },
        { key: 'Already certified to another system', value: 'Already certified to another system' },
        { key: 'Processes involve a single general activity', value: 'Processes involve a single general activity' },
        { key: 'Maturity of management system', value: 'Maturity of management system' },
        { key: 'High % of employees doing the same, simple tasks', value: 'High % of employees doing the same, simple tasks' },
        { key: 'Identical activities performed on all shifts', value: 'Identical activities performed on all shifts' },
        { key: 'Repetitive Activities', value: 'Repetitive Activities' },
        { key: 'No. of Work Shifts with same activities', value: 'No. of Work Shifts with same activities' },
        { key: 'Previously demonstrate performance of the ISMS', value: 'Previously demonstrate performance of the ISMS' },
    ]
    const certificateactivityType = [
        { key: 'Select', value: '-' },
        { key: 'Renewal', value: 'Renewal' },
        { key: 'Initial certification', value: 'Initial certification' },
        { key: 'Transfer from another CB', value: 'Transfer from another CB' },
        { key: 'Extra ordinary audit', value: 'Extra ordinary audit' }
    ]
    const ValidationSchema = Yup.object({
        orgCode: Yup.string().required('Required!!'),
        // reqDate                         :  Yup.string().required('Required!!'),
        contractDate: Yup.string().required('Required!!'),
        riskLevel: Yup.string().required('Required!!'),
        noOfShifts: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        sitesTobeCoveredInAudit: Yup.string().required('Required!!'),
        // nameOfConsultantOrBussinessAsso :  Yup.string().required('Required!!'),
        // mandays                         :  Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        mandaysPlanned: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        stageOneAudit: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        stageTwoAudit: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        //  remarkforInsDecMandyas          :   Yup.string().required('Required!!'),
        //   resonOfTransfer                 :  Yup.string().required('Required!!'),
        //auditTrainVerification: Yup.string().required('Required!!'),
       // scopeCoveredByaccreditation: Yup.string().required('Required!!'),
        outSourceActivity: Yup.string().required('Required!!'),
        notApplicableRequirement: Yup.string().required('Required!!'),
        //applicationAcceptedRejected: Yup.string().required('Required!!'),
        //approvedBy: Yup.string().required('Required!!'),
        externalReviewConductedBy: Yup.string().required('Required!!'),
        reviewConductedBy: Yup.string().required('Required!!'),
        // appvDate                        :  Yup.string().required('Required!!'),
        certificateactivitytype: Yup.string().required('Required!!'),
        certificatestandardtype: Yup.string().required('Required!!'),
        teamleader : Yup.string().required('Required!!'),
   

    });
    const { data: CertList, isLoading: certLoading } = useQuery(
        'listCert',
        () => Fetcher('get', '/api/typeofcertifications/get/typeofcertkeyvalue', {}))

    const onSubmit = (values, { setSubmitting, resetForm }) => {
        console.log("Values team leader name", values.teamleaderName)
        mutation.mutate(values)
    }
    const { orgcode } = useParams()
    // const { data: Rfqdata, isLoading } = useQuery(
    //     'listrfq',
    //     () => Fetcher('get', '/api/rfq/get/orgdetails/' + orgcode, {}))

    

    const mutationAssisAuditorDetails = useMutation((params) => Fetcher('get', '/api/profile/get/keyvalueforAssistAuditorCommonNacecode/' + params, {}), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {
                console.log("List of Auditor", data.data.response)
                setassitAuditorList(data.data.response)

            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const mutationAuditorListDetails = useMutation((params) => Fetcher('get', '/api/profile/get/keyvalueforAuditorCommonNacecode/' + params, {}), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {
                console.log("List of Auditor", data.data.response)
                setauditorList(data.data.response)

            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const mutation = useMutation((params) => Fetcher('patch', '/api/rfq/patch/contractreview', params), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {
                ToastInstance('Success', 'Contract Review Data Added')
              //  history.push("/" + localStorage.getItem("role") + '/view/contractreview/' + data.data.response.orgCode);
            } else {
                var msg = 'Contract Review - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Contract Review' + error)
        }
    })

    const mutationReviewerName = useMutation((params) => Fetcher('patch', '/api/profile/patch/userlistbyrolename', params), {
        onSuccess(data) {
            console.log("mutationReviewerName", data.data.response)
            if (data.data.errorCode === 0) {
                setReviewerNameList(data.data.response)

            } else {
                var msg = 'Contract Review - Reviewer Name' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Contract Review' + error)
        }
    })

    const mutationgetCompanyDetails = useMutation((params) => Fetcher('get', '/api/rfq/get/orgdetails/' + params, {}), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {
                var tempInitialValues = data.data.response;
                console.log("tempInitialValues",tempInitialValues)
                console.log("iso value 324",data.data.response.typeOfCertification)
                if(data.data.response.typeOfCertification === "ISO 27001-2013 ISMS Requirements"){
                    setShowData("ISO27001")
                }else{
                    setShowData("Iso9001")
                }
                tempInitialValues.effectiveNoEmpToBeAudited = data.data.response.effectiveNoEmpToBeAudited || "";
                tempInitialValues.noofshifts = data.data.response.noOfShifts || "";
                tempInitialValues.permanentTotal = data.data.response.permanentTotal || "";
                tempInitialValues.total = data.data.response.total || "";
                tempInitialValues.justificationEffNoEmpConsideration = data.data.response.justificationEffNoEmpConsideration || "";
                tempInitialValues.reqDate = Date.parse(data.data.response.ageOfPersonProvidingInfo) || null;
                tempInitialValues.contractDate = Date.parse(data.data.response.contractDate) || null;
                tempInitialValues.appvDate = Date.parse(data.data.response.appvDate) || null;
                tempInitialValues.increase = data.data.response.increase || "";
                tempInitialValues.decrease = data.data.response.decrease || "";
                tempInitialValues.increase1 = data.data.response.increase1 || "";
                tempInitialValues.decrease1 = data.data.response.decrease1 || "";
                tempInitialValues.fruquencyoftask = data.data.response.fruquencyoftask || "Annual";
                tempInitialValues.threatOne = data.data.response.threatOne || "No";
                tempInitialValues.threatTwo = data.data.response.threatTwo || "No";
                tempInitialValues.threatThree = data.data.response.threatThree || "No";
                tempInitialValues.threatFour = data.data.response.threatFour || "No";
                tempInitialValues.threatFive = data.data.response.threatFive || "No";
                tempInitialValues.threatSix = data.data.response.threatSix || "No";
                tempInitialValues.threatSeven = data.data.response.threatSeven || "No";
                tempInitialValues.threatEight = data.data.response.threatEight || "No";
                tempInitialValues.threatNine = data.data.response.threatNine || "No";
                tempInitialValues.threatTen = data.data.response.threatTen || "No";
                tempInitialValues.auditTrainVerification = data.data.response.auditTrainVerification || "Yes"
                tempInitialValues.scopeCoveredByaccreditation = data.data.response.scopeCoveredByaccreditation || "Yes"
                tempInitialValues.statusoOfApplication = data.data.response.statusoOfApplication || "";
                tempInitialValues.certificateactivitytype = data.data.response.certificateactivitytype || "Initial certification";
                
                tempInitialValues.approvedBy = data.data.response.approvedBy || "Vijay D"
                tempInitialValues.nacecode = data.data.response.nabcbcode
                if (tempInitialValues.nacecode && tempInitialValues.nacecode !== "") {
                 
                            mutationLeadAudiorDetails.mutate(tempInitialValues.nacecode)
                }
                if (tempInitialValues.nacecode && tempInitialValues.nacecode !== "") {
                    mutationTechnicalExpertDetails.mutate(tempInitialValues.nacecode)
                }
                if (tempInitialValues.nabcbcode && tempInitialValues.nabcbcode !== "") {
                    mutationAssisAuditorDetails.mutate(tempInitialValues.nabcbcode)
                }
                if (tempInitialValues.nabcbcode && tempInitialValues.nabcbcode !== "") {
                    mutationReviewerName.mutate(tempInitialValues.nabcbcode)
                }
                if (tempInitialValues.nabcbcode && tempInitialValues.nabcbcode !== "") {
                    mutationAuditorListDetails.mutate(tempInitialValues.nabcbcode)
                }
                
                    setInitialValues(tempInitialValues)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
        }
    })
    const mutationLeadAudiorDetails = useMutation((params) => Fetcher('get', '/api/profile/get/keyvalueforleadauditorsCommonNacecode/' + params, {}), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {
                console.log("List of Auditor", data.data.response)
                setLeadauditorList(data.data.response)
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const mutationTechnicalExpertDetails = useMutation((params) => Fetcher('get', '/api/technicalexpert/get/labelvalueTechnicalExpertCommonNacecode/' + params, {}), {
        onSuccess(data) {
            console.log("data expert", data)

            if (data.data.errorCode === 0) {
                console.log("List of Technical Expert", data.data.response)
                setTechnicalExpertList(data.data.response)
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
          
            ToastInstance('Error', 'Subject' + error)
        }
    })
    // useEffect(() => {
    //     if (Rfqdata && initialValues.orgCode === 0) {
    //         var tempData = Rfqdata.data.response
    //         console.log("tempData", tempData)
    //         tempData.reqDate = Date.parse(tempData.reqDate) || null;
    //         tempData.contractDate = Date.parse(tempData.contractDate) || null;
    //         tempData.appvDate = Date.parse(tempData.appvDate) || null;
         
    //         if (tempData.nabcbcode && tempData.nabcbcode !== "") {
    //             mutationLeadAudiorDetails.mutate(tempData.nabcbcode)
    //         }
    //         if (tempData.nabcbcode && tempData.nabcbcode !== "") {
    //             mutationTechnicalExpertDetails.mutate(tempData.nabcbcode)
    //         }
    //         if (tempData.nabcbcode && tempData.nabcbcode !== "") {
    //             mutationAssisAuditorDetails.mutate(tempData.nabcbcode)
    //         }
    //         if (tempData.nabcbcode && tempData.nabcbcode !== "") {
    //             mutationReviewerName.mutate(tempData.nabcbcode)
    //         }

            
    //         setInitialValues(tempData)


    //     }
    // }, [orgcode && !isLoading && initialValues.orgCode === 0])

    const getUrl = () =>{
        const api= APIURL + '/api/rfq/get/orgdetails/' +orgcode
        axios.get(api , { headers: {"Authorization" : 'Bearer ' + localStorage.getItem("token")} })
        .then(Rfqdata=>{
       
            if (Rfqdata && initialValues.orgCode === 0 && Rfqdata.data.response.statusoOfApplication === 'Accepted') {
                var tempData = Rfqdata.data.response
                console.log("Rfqdata.data.response",Rfqdata.data.response)
                tempData.reqDate = Date.parse(tempData.reqDate) || null;
                tempData.contractDate = Date.parse(tempData.contractDate) || null;
                tempData.appvDate = Date.parse(tempData.appvDate) || null;
                if(!tempData.statusoOfApplication){
                  return <h1>Staus of Application is not filled</h1>
                }
            if (tempData.nabcbcode && tempData.nabcbcode !== "") {
                mutationLeadAudiorDetails.mutate(tempData.nabcbcode)
            }
            if (tempData.nabcbcode && tempData.nabcbcode !== "") {
                mutationTechnicalExpertDetails.mutate(tempData.nabcbcode)
            }
            if (tempData.nabcbcode && tempData.nabcbcode !== "") {
                mutationAssisAuditorDetails.mutate(tempData.nabcbcode)
            }
            if (tempData.nabcbcode && tempData.nabcbcode !== "") {
                mutationReviewerName.mutate(tempData.nabcbcode)
            }

            
            setInitialValues(tempData)

            }
        })
        .catch(err=>{
            var string= JSON.stringify(err).split("/")[0]
            const regex = /401/g;
            const found = string.match(regex);
            
            console.log("found",found);
            if(found !== null){
                console.log(err)
                window.location.href = "/signin"
            }
         

        })
    }
   
    useEffect(() => {
        if(orgcode!== undefined){
            getUrl()
        }
       
    }, [orgcode!== undefined])

   
    const { data: nacecodeList, isLoading: nacecodeListLoading } = useQuery(
        'listnacecode',
        () => Fetcher('get', '/api/nace/get/listnacecodewithkeylabel', {}))

    const { data: OrgList, isLoading: companyListLoading } = useQuery(
        'listAuditPlan',
        () => Fetcher('get', '/api/clientaccess/get/listofcompaniesrfqdata/' + localStorage.getItem("userCode"), {}))

    if (companyListLoading || nacecodeListLoading) return <h1>Loading</h1>
    if (orgcode && initialValues.orgCode === 0){
       
    //  window.location.href = "/signin"
       return <h1>Loading Data</h1>
      
    }
    return (
        <div>
            <Formik
                enableReinitialize={true}
                // validationSchema={ValidationSchema}
                initialValues={initialValues}
                onSubmit={onSubmit}
            >
                {
                    formik => (
                        <Form>
                            <div className="content-wrapper">
                                <section className="content">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="card-body">
                                                    <div className="formOuterDiv">
                                                        <div className="hrstyle headingcolor">
                                                            <h5>General Information</h5>
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='selectNACECode' label='Company Name' options={OrgList.data.response} name='orgCode' onChange={e => { mutationgetCompanyDetails.mutate(e.value); }} />
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type='text' label='Address' name='address' disabled={true} />
                                                        </div>

                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type='text' label='Scope' name='scope' disabled={true} />
                                                        </div>
                                                        <div className="form2RowDiv">
                                                            <FormikControl control='date' dateFormat="dd-MM-yyyy" label='Request Date' name='reqDate' />
                                                            <FormikControl control='date' dateFormat="dd-MM-yyyy" label='Contract Date*' name='contractDate' maxDate={new Date()} />
                                                        </div>

                                                        <div className="form2RowDiv">
                                                            <FormikControl control='select' label='Risk Level*' options={rsklevel} name='riskLevel' />
                                                            <FormikControl control='input' type="text" label='NACE Code' name='nabcbcodeName' disabled={true} />

                                                        </div>

                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type="text" label='No Of Shifts*' name='noOfShifts' style={{ textAlign: "right" }} />
                                                            <FormikControl control='input' type="text" label='Permenant Employees' name='permanentTotal' disabled={true} style={{ textAlign: "right" }} />

                                                        </div>
                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type="text" label='Employees Per Shift / Part Time Employees' name='partTimeTotal' disabled={true} style={{ textAlign: "right" }} />
                                                            <FormikControl control='input' type="text" label='Temporary Employees' name='contractualTotal' disabled={true} style={{ textAlign: "right" }} />

                                                        </div>
                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type="text" label='Total No of Employees' name='total' disabled={true} style={{ textAlign: "right" }} />
                                                            <FormikControl control='input' type="text" label='Effective Number of Employees to be Audited' name='effectiveNoEmpToBeAudited' disabled={true} style={{ textAlign: "right" }} />

                                                        </div>

                                                        <div className="row  note">
                                                            <p >(<i><b> Note:- </b>For repetitive processes and for shifts the effective numbers may be reduced*)
                                                                Justification for Effective Number of Employees Consideration:-
                                                                ( Ex- Shift/ Repetitive Work/ unskilled Employees)</i></p>
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='input' type="text" label='Justification for Effective Number of Employees Consideration ' name='justificationEffNoEmpConsideration' disabled={true} />
                                                        </div>

                                                        <div className="row note ">
                                                            <p >(<i><b> Note:- </b>  For repetitive processes and for shifts the effective numbers may be reduced*)
                                                                ( Ex- Shift/ Repetitive Work/ unskilled Employees)</i></p>
                                                        </div>
                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type="text" label='Sites to be covered in Audit*' name='sitesTobeCoveredInAudit' style={{ textAlign: "right" }}/>
                                                            <FormikControl control='input' type="text" label='Name of the Consultant / Business associates (If any)' name='nameOfConsultantOrBussinessAsso' />
                                                        </div>
                                                        <div className="hrstyle headingcolor">
                                                            <h5>Mandays required (Stage1 & Stage 2/Recertification)</h5>
                                                        </div>
                                                        <div className="form2RowDiv">
                                                            {/* <FormikControl control='input' type="text" label='Mandays required (Stage1 & Stage 2/Recertification)'  name='mandays' style={{textAlign:"right"}}/> */}
                                                            <FormikControl control='input' type="text" label='Mandays Planned*' name='mandaysPlanned' style={{ textAlign: "right" }} />
                                                        </div>
                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type="text" label='Stage 1 Audit*' name='stageOneAudit' style={{ textAlign: "right" }} />
                                                            <FormikControl control='input' type="text" label='Stage 2 Audit*' name='stageTwoAudit' style={{ textAlign: "right" }} />
                                                        </div>

                                                        <div className="note">
                                                            <p className="mt-3"><i><b>Note: -</b> For each justification of decrease 10% reduction will be given, in any case not exceeding 30%.
                                                                MT in consultation with DT ensure that the auditor allocation & audit planning/s scheduling is done in such a way that spending of 80% time onsite is conveyed/ confirmed with auditors.
                                                            </i></p>
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type='text' label='Remarks for Reducing/ Increasing the Mandays with respect to effective number of employees/ scope and Risk Level  ' name='remarkforInsDecMandyas' />
                                                        </div>
                                                        <div className="form2RowDiv">
                                                            <FormikControl control='select' label='Certification Standard Type*' options={CertList.data.response} name='certificatestandardtype' />
                                                            <FormikControl control='select' options={certificateactivityType} name='certificateactivitytype' label='Certification Activity Type*' />

                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type='text' label='Reason of the transfer to IQCPL from another Certification Body ' name='resonOfTransfer' />
                                                        </div>

                                                        <div className="hrstyle headingcolor">
                                                            <h5>Any threat to impartiality</h5>
                                                        </div>


                                                        <div className="row">

                                                            <div className="row ">
                                                                <div>
                                                                    <div class="card-body table-responsive">
                                                                        <table className="table table-bordered">
                                                                            <thead className="table-primary">
                                                                                <tr>
                                                                                    <th>#</th>
                                                                                    <th scope="col" className="text-center" width="50%">Type of Threat</th>
                                                                                    <th scope="col" className="text-center">Yes/No</th>
                                                                                    <th scope="col" className="text-center">Comments/Remarks</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody >
                                                                                <tr >
                                                                                    <td className="text-center" >1</td>
                                                                                    <td>Ownership, Governance and Management Current boards of directors are responsible for this area.
                                                                                    </td>
                                                                                    <td className="col-sm-2">
                                                                                        <FormikControl control='selecttable' options={impartialityoptions} name='threatOne' style={{ textAlign: "center" }} /></td>
                                                                                    <td ><FormikControl control='inputtable' type="text" name='threatOneremark' className="form-control" /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">2</td>
                                                                                    <td>Personnel (on Roll) at auditing/Review-Relatives working in top level.
                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={impartialityoptions} name='threatTwo' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='threatTworemark' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">3</td>
                                                                                    <td>-Previous Employment
                                                                                        -Holding Shares with the organization to be Certified.
                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={impartialityoptions} name='threatThree' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='threatThreeremark' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">4</td>
                                                                                    <td>Impartiality in Handling Application from own group of companies
                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={impartialityoptions} name='threatFour' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='threatFourremark' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">5</td>
                                                                                    <td>The possibility of Impartial Committee member influencing the auditing process
                                                                                        If the Impartial committee member has any link with Client organization.
                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={impartialityoptions} name='threatFive' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='threatFiveremark' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">6</td>
                                                                                    <td>May be the clients representative is having the financial interest in IQCPL
                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={impartialityoptions} name='threatSix' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='threatSixremark' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">7</td>
                                                                                    <td>May be the impartiality committee members have association with the clients.
                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={impartialityoptions} name='threatSeven' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='threatSevenremark' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">8</td>
                                                                                    <td>Marketing Team may offer quick/Easy certification and may propose to do the consultancy and audits.
                                                                                        Employees of the clients may offer the above situation
                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={impartialityoptions} name='threatEight' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='threatEightremark' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">9</td>
                                                                                    <td>Repeatedly sending the same auditor to the clients place may have an impact by development of the relationship
                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={impartialityoptions} name='threatNine' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='threatNineremark' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">10</td>
                                                                                    <td>Family Members are directly involved in operating the management system consultancy business
                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={impartialityoptions} name='threatTen' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='threatTenremark' /> </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="form2RowDiv">
                                                            <FormikControl control='select' options={impartialityoptions} name='auditTrainVerification' label='Auditor training verification*' />
                                                            <FormikControl control='select' options={impartialityoptions} name='scopeCoveredByaccreditation' label='Is the scope covered by accreditation?*' />

                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='input' type='text' label='Outsource activities performed ' name='outSourceActivity' />
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type='text' label=' Does your company have any Not Applicable requirements identified,
                                                                    if yes please list them out and provide the reasons ' name='notApplicableRequirement' />
                                                        </div>


                                                        <div className="hrstyle headingcolor ">
                                                            <h5>Surveillance</h5>
                                                        </div>
                                                        <div className="form2RowDiv">
                                                            <FormikControl control='select' options={fruquencyoftask} name='fruquencyoftask' label='Frquency of Task*' />
                                                            <FormikControl control='input' name='surveillancemandays' label='Mandays*' type='text' />
                                                        </div>
                                                        <div className="hrstyle headingcolor">
                                                            <h5>Select Qualified Resource to Audit</h5>
                                                        </div>


                                                        <div className="form2RowDiv">
                                                            <FormikControl control='selectNACECode' label='Qualified Lead Auditor to appoint*' options={leadauditorList} name='teamleader' onChange={(e) => {

                                                                formik.setFieldValue(`teamleader`, parseInt(e.value))
                                                                formik.setFieldValue(`teamleaderName`, e.label)

                                                            }}

                                                                values={(leadauditorList).find(i => i.value === `teamleader`)} />

                                                            <FormikControl control='selectNACECode' label='Technical Expert' options={technicalExpertList} name='technicalexpert'
                                                                onChange={(e) => {

                                                                    formik.setFieldValue(`technicalexpert`, e.value)
                                                                    formik.setFieldValue(`technicalExpertName`, e.label)
                                                                }}

                                                                values={(technicalExpertList).find(i => i.value === `technicalexpert`)} />

                                                        </div>
                                                        <div className="form2RowDiv">

                                                            <FormikControl control='selectNACECode' label='Auditor 1' name='auditorOne' options={assitAuditorList}
                                                                onChange={(e) => {

                                                                    formik.setFieldValue(`auditorOne`, parseInt(e.value))
                                                                    formik.setFieldValue(`auditorOneName`, e.label)
                                                                }}

                                                                values={(assitAuditorList).find(i => i.value === `auditorOne`)}
                                                            />

                                                            <FormikControl control="selectNACECode" name="auditorTwo" label='Auditor 2' options={auditorList}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`auditorTwo`, e.value)
                                                                    formik.setFieldValue(`auditorTwoName`, e.label)
                                                                }}
                                                                values={(auditorList).find(i => i.value === `auditorOne`)}
                                                            />

                                                        </div>



                                                        <div className="row mt-3" style={{ display: (showData === "Iso9001" ? 'block' : 'none') }}>
                                                            <label htmlFor="staticEmail" className="col-sm-8 ml-3 radiolabel ">Reason for the reduction/increase of M/D<span style={{color:"red"}}>*</span></label>
                                                            <div >
                                                                <div className="card-body table-responsive myClass">
                                                                    <table className="table ">
                                                                        <tr>
                                                                            <th className="text-center"> Increase </th>
                                                                            <th className="text-center">Decrease</th>
                                                                        </tr>
                                                                        <tr className="col-sm-10" style={{ verticalAlign: "top !important" }}>
                                                                            <td className="col-sm-4">
                                                                                <FormikControl control='checkbox' name='increase' options={increase} />
                                                                            </td>
                                                                            <td className="col-sm-4">
                                                                                <FormikControl control='checkbox' name='decrease' options={decrease} />
                                                                            </td>
                                                                        </tr>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-3" style={{ display: (showData === "ISO27001" ? 'block' : 'none') }}>
                                                            <label htmlFor="staticEmail" className="col-sm-8 ml-3 radiolabel ">Reason for the reduction/increase of M/D<span style={{color:"red"}}>*</span></label>
                                                            <div >
                                                                <div className="card-body table-responsive myClass">
                                                                    <table className="table ">
                                                                        <tr>
                                                                            <th className="text-center"> Increase </th>
                                                                            <th className="text-center">Decrease</th>
                                                                        </tr>
                                                                        <tr className="col-sm-10" style={{ verticalAlign: "top !important" }}>
                                                                            <td className="col-sm-4">
                                                                                <FormikControl control='checkbox' name='increase1' options={increase1} />
                                                                            </td>
                                                                            <td className="col-sm-4">
                                                                                <FormikControl control='checkbox' name='decrease1' options={decrease1} />
                                                                            </td>
                                                                        </tr>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="form2RowDiv" style={{ marginTop: "-2%" }}>
                                                            <FormikControl control='select' label='Application Status*' options={Status} name='statusoOfApplication' />
                                                        </div>
                                                        
                                                                    <div className="form1RowDiv">
                                                                    
                                                                        <FormikControl control='textarea' type='text' label='Reason if declined/rejected' name='reasonForDecline' />
                                                                   
                                                                    </div>
                                                                   
                                                       
                                                        <div className="form2RowDiv">

                                                            <FormikControl control='select' options={Reviews} label='Review Conducted By*' name='reviewConductedBy'
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`reviewConductedBy`, e.currentTarget.value)
                                                                    mutationReviewerName.mutate({ role: e.currentTarget.value })
                                                                }}
                                                            />
                                                            <FormikControl control='selectNACECode' options={reviewerNameList} label='Reviewer Name' name='reviewerCode'
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`reviewerCode`, parseInt(e.value))
                                                                    formik.setFieldValue(`reviewerName`, e.label)
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="form2RowDiv manager">
                                                            <FormikControl control='input' type="text" label='External Review Conducted By*' name='externalReviewConductedBy' />
                                                        </div>

                                                        <div className="form2RowDiv">
                                                            {/* <FormikControl control='select' options={impartialityoptions} name='approvedBy' label='Approved by (DT)' /> */}
                                                            <FormikControl control='input' type="text" label='Approved by (DT)*' name='approvedBy' />
                                                            <FormikControl control='date' dateFormat="dd-MM-yyyy" label='Date*' name='appvDate' maxDate={new Date()} />
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                            {/* <div className="row">
                                <div className="col-lg-11"></div>
                                <div className="col-lg-1" style={{ marginBottom: "10PX" }}>
                                    <button type="submit" className="btn btn-primary">Submit</button>
                                </div>
                            </div> */}
                            <div className="card-footer">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        <button type="submit" className="btn btn-primary float-right" >Submit</button>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    )}
            </Formik>
        </div>

    )
}

export default NewContractReview